import React, { useEffect, useRef, useState } from 'react';

import { Modal } from 'flowbite';
import { usePopperTooltip } from 'react-popper-tooltip';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';
import TileTooltip from 'CommonComponents/TileTooltip';

import InformationCircleIcon from 'Assets/icons/information-circle.svg';

export default function ToggleSync(props) {
    const [configured, setConfigured] = useState(props.integrationConfigured);
    const [enabled, setEnabled] = useState(props.syncEnabled);
    const [request, setRequest] = useState(false);
    const [removeData, setRemoveData] = useState(false);
    const [type, setType] = useState(null);

    const [syncEnableModalElement, setSyncEnableModalElement] = useState(null);
    const [syncDisableModalElement, setSyncDisableModalElement] = useState(null);

    const syncEnableModalRef = useRef();
    const syncDisableModalRef = useRef();

    useEffect(() => {
        syncEnableModalRef && setSyncEnableModalElement(new Modal(syncEnableModalRef.current, modalOptions(false)));
        syncDisableModalRef && setSyncDisableModalElement(new Modal(syncDisableModalRef.current, modalOptions(false)));
        const defaultType = !!props.types && props.types.length > 0 ? props.types[0].key : null;
        setType(defaultType);
    }, []);

    useEffect(() => {
        setConfigured(props.integrationConfigured);
        setEnabled(props.syncEnabled);
    }, [props]);

    const resetData = () => {
        syncEnableModalElement && syncEnableModalElement.hide();
        syncDisableModalElement && syncDisableModalElement.hide();
    };

    const successHandler = () => {
        resetData();
    };

    const closeModal = () => {
        resetData();
    };

    const confirmEnableSync = () => {
        syncEnableModalElement && syncEnableModalElement.show();
    };

    const confirmDisableSync = () => {
        syncDisableModalElement && syncDisableModalElement.show();
    };

    const enableSync = () => {
        setRequest(true);
        toggleSync(true);
    };

    const disableSync = () => {
        setRequest(true);
        toggleSync(false);
    };

    const toggleRemoveData = () => {
        setRemoveData(!removeData);
    };

    const toggleSync = (enable) => {
        const syncType = enable && type ? type : null;
        const data = { action: props.action, enable, remove_data: removeData, type: syncType };

        axios
            .post(props.toggleUrl, data)
            .then((res) => {
                closeModal();
                setEnabled(res.data.syncEnabled);
                props.toggleCallback();
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const syncNow = () => {
        setRequest(true);
        axios
            .post(props.syncNowUrl)
            .then((res) => {
                alert(res.data.status);
                console.log(res);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const handleTypeChange = (e) => {
        setType(e.target.value);
    };

    return (
        <>
            {!!configured && !enabled && (
                <button className="button primary" onClick={confirmEnableSync}>
                    {$t('Import {{model}} from ERP', { model: props.modelName })}
                </button>
            )}
            <div id={props.toggleModalId} ref={syncEnableModalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Enable Import {{model}} from ERP', { model: props.modelName })} close={closeModal}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                {!props.hideDescription && (
                                    <div>
                                        <span className="tw-ml-2">
                                            {$t(
                                                '{{model}} will be synchronised on a daily basis. Once enabled, changes should be made in your external ERP system.',
                                                {
                                                    model: props.modelName,
                                                },
                                            )}
                                        </span>
                                    </div>
                                )}
                                {!props.hideDescription && (
                                    <div>
                                        <span className="tw-ml-2">
                                            {$t('Clicking "Enable" will archive all your existing {{model}} and replace with the ones from the ERP system.', {
                                                model: props.modelName,
                                            })}
                                        </span>
                                    </div>
                                )}

                                {!!configured && !enabled && !!props.types && props.types.length > 0 && (
                                    <div>
                                        <form>
                                            <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                <label className="text-input__label">{$t('Type')}</label>
                                                <div className="tw-h-8 tw-flex tw-items-center tw-gap-x-5" onChange={handleTypeChange}>
                                                    {props.types.map((item, index) => {
                                                        return <TypeInput key={item.key} item={item} type={type} />;
                                                    })}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )}

                                <div className="modal__footer">
                                    <Button variant="success" onClick={enableSync} disabled={request}>
                                        {$t('Enable')}
                                    </Button>

                                    <Button variant="secondary" onClick={closeModal}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!!configured && !!enabled && (
                <button className="button primary" onClick={confirmDisableSync}>
                    {$t('Disable Import {{model}} from ERP', { model: props.modelName })}
                </button>
            )}
            <div id="disable-gl-codes-sync" ref={syncDisableModalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Disable Import {{model}} from ERP', { model: props.modelName })} close={closeModal}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                <div>
                                    <span className="tw-ml-2">
                                        {$t('Do you really want to disable Import {{model}} from ERP?', { model: props.modelName })}
                                    </span>
                                </div>

                                {!!props.canRemoveData && (
                                    <div className="tw-py-1 tw-mx-3 tw-flex tw-items-center">
                                        <div className="tw-col-auto tw-mr-3">
                                            <label htmlFor="central-contingency" className="tw-text-blue tw-font-bold tw-text-sm tw-mb-0">
                                                {props.removeHeader}:
                                            </label>
                                        </div>
                                        <div className="tw-col-auto tw-px-1 tw-mr-3">
                                            <div className="toggl-input" onClick={toggleRemoveData}>
                                                <input
                                                    id={`toggle-button-delete-data`}
                                                    className="toggl-input-checkbox"
                                                    name={`activate_delete_data`}
                                                    type="checkbox"
                                                    checked={!!removeData}
                                                    onChange={toggleRemoveData}
                                                    data-action="toggle-slider"
                                                />
                                                <label className="toggl-input-label tw-mb-0"></label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="modal__footer">
                                    <Button variant="success" onClick={disableSync} disabled={request}>
                                        {$t('Disable')}
                                    </Button>

                                    <Button variant="secondary" onClick={closeModal}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!!configured && !!enabled && (
                <button className="button primary tw-ml-3" onClick={syncNow} disabled={request}>
                    {request && <i className="fa fa-spinner fa-spin " aria-hidden="true"></i>}
                    {$t('Import {{model}} now', { model: props.modelName })}
                </button>
            )}
        </>
    );
}

const TypeInput = (props) => {
    const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({ placement: 'right', trigger: 'click' });

    return (
        <div className="tw-py-1 tw-mx-10 tw-flex tw-items-center">
            <div>
                <label className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-font-semibold tw-text-charcoal-50">
                    <input type="radio" name="type" value={props.item.key} checked={props.type === props.item.key} />
                    {props.item.name}
                </label>
            </div>

            <div className="tw-col-auto tw-px-1 tw-pb-3 tw-flex tw-items-center">
                <button type="button" ref={setTriggerRef}>
                    <InformationCircleIcon className="tw-mt-0 tw-mb-0 tw-p-0 tw-cursor-pointer" />
                </button>
            </div>
            {!!visible && (
                <TileTooltip ref={setTooltipRef} tooltipText={props.item.description} getTooltipProps={getTooltipProps} getArrowProps={getArrowProps} />
            )}
        </div>
    );
};
